export const translations = {
  da: {
    // Navbar
    nav_home: 'Forside',
    nav_destinations: 'Rejsemål',
    nav_hotels: 'Hoteller',
    nav_prices: 'Priser',
    nav_about: 'Om Alora',
    nav_traveltips: 'Rejsetips',
    nav_contact: 'Kontakt',
    nav_quote: 'Indhent Tilbud',
    nav_terms: 'Rejsebetingelser',
    practical_info_header: 'Praktisk information',
    gallery_header: 'Galleri',
    nav_gdpr: 'GDPR & Privatliv',
    nav_consent: 'Samtykke',
    nav_search_placeholder: 'Søg på hjemmesiden...',
    nav_search_aria: 'Søg på hjemmesiden',

    // Footer
    footer_tagline: 'Udvalgte rejser med fokus på tilgængelighed, hvor vi ønsker at skabe trygge rammer og uforglemmelige oplevelser for alle, uanset mobilitet.',
    footer_info_header: 'Information',
    footer_privacy_header: 'Privatliv',
    footer_newsletter_header: 'Tilmeld nyhedsmail',
    footer_newsletter_desc: 'Få inspiration til din næste rejse og gode råd om tilgængelighed direkte i din indbakke.',
    footer_newsletter_placeholder: 'Din e-mail adresse',
    footer_newsletter_button: 'Tilmeld',
    footer_newsletter_success: 'Tak for din tilmelding!',
    footer_newsletter_error: 'Der skete en fejl. Prøv venligst igen.',
    footer_copyright: '© 2026 Alora Rejser. CVR: 46391772. Alle rettigheder forbeholdes.',
    footer_cvr: 'CVR',

    // General UI
    ui_read_more: 'Læs mere',
    ui_view_hotels: 'Se hoteller',
    ui_tour_suggestions: 'Se turforslag',
    ui_back: 'Tilbage',
    ui_back_to_hotels: 'Tilbage til hoteller',
    ui_back_to_destinations: 'Tilbage til rejsemål',
    ui_distances: 'Afstande',
    ui_features: 'Faciliteter',
    ui_highlights: 'Højdepunkter',
    ui_price_from: 'Pris fra',
    ui_seasonal_prices: 'Sæsonpriser',
    ui_accessibility: 'Tilgængelighed',
    ui_search_results: 'Søgeresultater for',
    ui_no_results: 'Ingen resultater fundet',
    ui_search_placeholder: 'Søg efter destinationer, hoteller...',
    ui_close: 'Luk',
    ui_stars: 'Stjerner',
    ui_coming_soon: 'Kommer snart',
    ui_contact_us: 'Kontakt os',
    ui_send_message: 'Send besked',
    ui_send_request: 'Send forespørgsel',
    ui_loading: 'Indlæser...',

    // Distances
    dist_restaurant: 'Restaurant',
    dist_centrum: 'Centrum',
    dist_hospital: 'Hospital',
    dist_pharmacy: 'Apotek',
    dist_airport: 'Lufthavn',
    dist_beach: 'Strand/Sø',

    // Contact Form
    form_name: 'Fulde navn',
    form_email: 'E-mail adresse',
    form_phone: 'Telefonnummer',
    form_message: 'Besked',
    form_destination: 'Vælg destination',
    form_hotel: 'Vælg hotel',
    form_departure: 'Forventet afrejsedato',
    form_duration: 'Varighed (antal dage)',
    form_travelers: 'Antal rejsende',
    form_wheelchairs: 'Antal kørestolsbrugere',
    form_special_needs: 'Særlige behov eller ønsker',
    form_success_title: 'Tak for din henvendelse!',
    form_success_desc: 'Vi har modtaget din besked og vender tilbage til dig hurtigst muligt.',
    form_error_title: 'Der skete en fejl',
    form_error_desc: 'Kunne ikke indsende formularen. Prøv venligst igen eller kontakt os direkte.',

    // SEO Default
    seo_default_title: 'Alora Rejser | Handicapvenlige & Tilgængelige Rejser',
    seo_default_desc: 'Alora Rejser tilbyder skræddersyede, handicapvenlige og tilgængelige rejser for kørestolsbrugere og gangbesværede. Oplev tryghed, komfort og gennemtænkt kvalitet.'
  },
  en: {
    // Navbar
    nav_home: 'Home',
    nav_destinations: 'Destinations',
    nav_hotels: 'Hotels',
    nav_prices: 'Prices',
    nav_about: 'About Alora',
    nav_traveltips: 'Travel Tips',
    nav_contact: 'Contact',
    nav_quote: 'Request Quote',
    nav_terms: 'Terms & Conditions',
    practical_info_header: 'Practical Information',
    gallery_header: 'Gallery',
    nav_gdpr: 'GDPR & Privacy Policy',
    nav_consent: 'Consent',
    nav_search_placeholder: 'Search website...',
    nav_search_aria: 'Search website',

    // Footer
    footer_tagline: 'Selected holidays with focus on accessibility, where we want to create safe environments and unforgettable experiences for everyone, regardless of mobility.',
    footer_info_header: 'Information',
    footer_privacy_header: 'Privacy',
    footer_newsletter_header: 'Newsletter Signup',
    footer_newsletter_desc: 'Get inspiration for your next trip and good advice on accessibility directly in your inbox.',
    footer_newsletter_placeholder: 'Your email address',
    footer_newsletter_button: 'Subscribe',
    footer_newsletter_success: 'Thank you for subscribing!',
    footer_newsletter_error: 'An error occurred. Please try again.',
    footer_copyright: '© 2026 Alora Rejser. CVR: 46391772. All rights reserved.',
    footer_cvr: 'CVR',

    // General UI
    ui_read_more: 'Read more',
    ui_view_hotels: 'View hotels',
    ui_tour_suggestions: 'View tour suggestions',
    ui_back: 'Back',
    ui_back_to_hotels: 'Back to hotels',
    ui_back_to_destinations: 'Back to destinations',
    ui_distances: 'Distances',
    ui_features: 'Features',
    ui_highlights: 'Highlights',
    ui_price_from: 'Price from',
    ui_seasonal_prices: 'Seasonal prices',
    ui_accessibility: 'Accessibility',
    ui_search_results: 'Search results for',
    ui_no_results: 'No results found',
    ui_search_placeholder: 'Search for destinations, hotels...',
    ui_close: 'Close',
    ui_stars: 'Stars',
    ui_coming_soon: 'Coming soon',
    ui_contact_us: 'Contact us',
    ui_send_message: 'Send message',
    ui_send_request: 'Send request',
    ui_loading: 'Loading...',

    // Distances
    dist_restaurant: 'Restaurant',
    dist_centrum: 'Center',
    dist_hospital: 'Hospital',
    dist_pharmacy: 'Pharmacy',
    dist_airport: 'Airport',
    dist_beach: 'Beach/Lake',

    // Contact Form
    form_name: 'Full name',
    form_email: 'Email address',
    form_phone: 'Phone number',
    form_message: 'Message',
    form_destination: 'Select destination',
    form_hotel: 'Select hotel',
    form_departure: 'Expected departure date',
    form_duration: 'Duration (number of days)',
    form_travelers: 'Number of travelers',
    form_wheelchairs: 'Number of wheelchair users',
    form_special_needs: 'Special needs or requests',
    form_success_title: 'Thank you for your inquiry!',
    form_success_desc: 'We have received your message and will get back to you as soon as possible.',
    form_error_title: 'An error occurred',
    form_error_desc: 'Could not submit the form. Please try again or contact us directly.',

    // SEO Default
    seo_default_title: 'Alora Rejser | Accessible & Wheelchair Friendly Holidays',
    seo_default_desc: 'Alora Rejser offers tailored, wheelchair friendly and accessible holidays. Experience safety, comfort and carefully planned quality.'
  }
};
